import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

import { Button } from '~/ui/core/button/Button';

export type PriorityToastAction = { readonly label: string; readonly onClick: () => void };

/** What a prioritization did, then what can follow it, such as adding the scope's other tasks. */
export const PriorityToast: FunctionComponent<{
    readonly actions: readonly PriorityToastAction[];
    readonly text: string;
}> = ({ actions, text }) => (
    <span
        className="flex flex-wrap items-center gap-x-s gap-y-xs"
        data-testid="ai-transformation-strategy-priority-toast"
    >
        <span>{text}</span>
        {actions.map((action) => (
            <Fragment key={action.label}>
                <span aria-hidden={true}>·</span>
                <Button className="!text-inherit underline" size="sm" variant="link" onClick={action.onClick}>
                    {action.label}
                </Button>
            </Fragment>
        ))}
    </span>
);
